export const getSecondDomainName = (url: string): string => {
  try {
    const urlObj = new URL(url);
    const hostname = urlObj.hostname;
    const domainParts = hostname.split('.');

    if (domainParts.length >= 2) {
      const secondLevelDomain = domainParts[domainParts.length - 2];
      return secondLevelDomain.toUpperCase();
    }
    return hostname.toUpperCase();
  } catch {
    return 'Partner';
  }
};

// In the future, we may wish to pull this list dynamically from the backend.
// This list should contain the hostnames of partners with whom we have,
// or will shortly have, an embedded integration.
export const VALID_PARTNER_HOSTNAMES = [
  'www.adp.com',
  'trinet.com',
  '*.hrpassport.com',
  '*.isolvedhcm.com',
  'secure.justworks.com',
  'workforcenow.adp.com',
  'workforcenow.cloud.adp.com',
  'runpayrollmain2.adp.com',
  'runpayrollmain.adp.com',
  'main.d2ayxrxgktg23j.amplifyapp.com',
];

export const isValidExternalRedirectUrl = (url: string): boolean => {
  const urlObj = new URL(url);
  const hostname = urlObj.hostname;

  if (urlObj.protocol !== 'https:') {
    return false;
  }

  return VALID_PARTNER_HOSTNAMES.some(pattern => {
    if (pattern.startsWith('*.')) {
      const domain = pattern.slice(2);
      return hostname.endsWith('.' + domain);
    }
    return hostname === pattern;
  });
};
